/* eslint-disable no-unused-expressions */
import store from './../common/store';
import * as s2sActions from './actions';
import isEmpty from 'lodash/isEmpty';
import Axios from './../common/helpers/axiosUtil';
import bpClientLogger from './../common/helpers/bpClientLogger';

window.enableS2Slogger = false;
const _c = console;
const _log = _c.log.bind(_c);

const print = info => {
  if (window.enableS2Slogger) {
    _log(info);
  }
};

const _events = {
  init: 'INIT',
  pause: 'PAUSE_IDLE_TIME_TRACKER',
  resume: 'RESUME_IDLE_TIME_TRACKER',
  failed: 'USER_AUTH_FAILED',
  ptbActive: 'PTB_ACTIVE',
  ptbLogout: 'PTB_LOGOUT',
};

const SM_API = '/apps/ptb/api/sm';
let PAST_ACTIVITY_TIMESTAMP = null;

class BrokerS2SManager {
  constructor() {
    this.configs = {};
    this.idle_time_counter = 0;
    this.session_constant = 1000;
    this.references = {
      shop: {},
      made: {},
      mproducer: {},
      salesforce: {},
      getcertified: {},
    };
    this.timer = null;
    this.refreshTimer = null;
  }

  initApp() {
    const { homeReducers = {} } = store.getState();
    const configsFromRemoteServer = homeReducers?.config?.data?.s2sConfigs || {};
    this.configs = configsFromRemoteServer;
    if (!isEmpty(this.configs)) {
      this.timeTracker();
      this.messageHub();
      this.sessionRefreshTracker();
    }
  }

  resetIdleTime() {
    this.idle_time_counter = 0;
    this.postMessageHandlerGeneric(_events.resume);
    this.postMessageHandlerGeneric(_events.ptbActive);
    print(`s2s_counter_resets= ${this.idle_time_counter}`);
  }

  userAuthFailed() {
    this.postMessageHandlerGeneric(_events.failed);
    this.postMessageHandlerGeneric(_events.ptbLogout);
  }

  userLogout() {
    this.postMessageHandlerGeneric(_events.ptbLogout);
  }

  redirectToLogoutAndEmitEvent() { 
    // trigger event first
    this.userLogout();
    // then redirect to logout route
    bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
    const logoutUrl = store.getState()?.homeReducers?.config?.urls?.logout || '/apps/ptb/logout';
    window.location.href = logoutUrl; //logout will inject here
  }

  timeTracker() {
    const timeTrackerInterval = this.configs?.intervalConstant * 60 * 1000;
    if (this.timer !== null) return;
    this.timer = setInterval(
      function() {
        ++this.idle_time_counter;
        print(`s2s_counter= ${this.idle_time_counter}`);
        this.checkIdleTimeExceedsTimeout();
      }.bind(this),
      timeTrackerInterval
    );
  }

  clearTimeTracker() {
    clearInterval(this.timer);
    clearInterval(this.refreshTimer);
    this.idle_time_counter = 0;
    this.timer = null;
    this.refreshTimer = null;
  }

  setReferences(params) {
    const { _ref, _url, _app } = params;
    for (let key in this.references) {
      if (key === _app && _url) {
        this.references[key]._ref = _ref;
        this.references[key]._url = _url;
      }
    }
  }

  postMessageHandlerGeneric(event) {
    for (let key in this.references) {
      if (!isEmpty(this.references[key])) {
        const ref = this.references[key]?._ref;
        const url = this.references[key]?._url;
        if (ref) {
          ref.postMessage({ event }, url);
        }
      }
    }
  }

  postMessageHandlerInit(portal) {
    if (!isEmpty(this.references[portal])) {
      const ref = this.references[portal]?._ref;
      const url = this.references[portal]?._url;
      if (ref) {
        ref.postMessage({ ...this.configs?.portals[portal], event: 'INIT' }, url);
      }
    }
  }

  checkIdleTimeExceedsTimeout() {
    const sessionConstant = this.configs?.sessionConstant;
    if (this.idle_time_counter > sessionConstant) {
      bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
      store.dispatch(s2sActions.showLogin(true));
      this.postMessageHandlerGeneric(_events.pause);
    }
  }

  getCurrentTime() {
    return new Date().getTime();
  }

  sessionRefreshTracker() {
    const currentTime = this.getCurrentTime();
    const sessionRefreshInterval = this.configs?.sessionConstant * 60 * 1000;
    const latestActivityTimestamp = currentTime - sessionRefreshInterval;
    if (this.refreshTimer !== null) return;
    this.refreshTimer = setInterval(function() {
      if (PAST_ACTIVITY_TIMESTAMP > latestActivityTimestamp) {
        Axios.get(SM_API).then(() => {});
      }
    }, sessionRefreshInterval);
  }

  sendUpdatedConfigurations(data, portal) {
    switch (data?.event) {
      case 'ACTIVITY_SYNC': {
        this.idle_time_counter = 0;
        PAST_ACTIVITY_TIMESTAMP = this.getCurrentTime();
        print(`s2s_sync_activity_from_${portal}, counter= ${this.idle_time_counter}`);
        break;
      }
      case 'INIT': {
        this.idle_time_counter = 0;
        print(`s2s_init_activity_from_${portal}, counter= ${this.idle_time_counter}`);
        this.postMessageHandlerInit(portal);
        break;
      }
      case 'MPRODUCER_LOGOUT': {
        this.idle_time_counter = 0;
        print(`s2s_logout_event_from_${portal}, counter=${this.idle_time_counter}`);
        this.redirectToLogoutAndEmitEvent();
        break;
      }
    }
  }

  getPortalName(s, o) {
    for (let key in this.references) {
      // eslint-disable-next-line eqeqeq
      if (s == this.references[key]?._ref) return key;
      if (o.toLowerCase().indexOf('mproducer') > -1) return 'mproducer';
      if (s?.name?.toLowerCase().indexOf('bpframe') > -1) return 'salesforce';
      if (o.toLowerCase()?.includes('getcertified')) return 'getcertified';
    }
    return '';
  }

  receivedMessageHandler(event) {
    const { data = {}, source = {}, origin = '' } = event;
    const portal = this.getPortalName(source, origin);
    print(`s2s_get_portal_name=${portal}, event=${data?.event}`);
    if (portal) {
      print(`s2s_received_data_from_${portal}, active=${data?.active}`);
      if (data?.active) {
        this.sendUpdatedConfigurations(data, portal);
      } else if (data?.event === 'MPRODUCER_LOGOUT') {
        this.sendUpdatedConfigurations(data, portal);
      }
    }
  }

  receiveMessage() {
    window.addEventListener(
      'message',
      event => {
        // BPP-113355 - reset idle time when chat is active
        if (
          (event.data?.type && event.data.type === 'PA-SEND-MESSAGE-ACTIVITY') ||
          (event.data && event.data === 'open_aca_chat') ||
          (event.data && event.data === 'DRV_ACTIVITY_SYNC') ||
          (event?.origin?.includes('getcertified') && event?.data?.includes('keepalive'))
        ) {
          this.resetIdleTime();
        } else {
          this.receivedMessageHandler(event);
        }
      },
      false
    );
  }

  messageHub() {
    this.receiveMessage();
  }
}

const instance = new BrokerS2SManager();
export default instance;
